import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class OnboardingLabelService {
  private labels: Record<number, string> = {
    0: 'El usuario inició el proceso de onboarding (pantalla de bienvenida)',
    1: 'El usuario visualizó la pantalla para ingresar clave del SII',
    2: 'Seleccionar facturador',
    3: 'Pantalla no utilizada actualmente',
    4: 'Mirai aprueba y el cliente tiene una simulación disponible',
    5: 'Mirai no aprueba al cliente',
    6: 'Resumen de la simulación',
    11: 'Riesgo rechazó al cliente',
    12: 'El cliente no necesita realizar onboarding',
    13: 'Mirai aprobó, pero no se logró crear la simulación'
  };

  getLabel(step: number): string {
    return this.labels[step];
  }
}
